import { serverTime } from '../../core/time/business-time';
const JST_OFFSET = 9 * 60 * 60 * 1000;
const DAY = 24 * 60 * 60 * 1000;
const DATE = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/;

export function jstDayStart(value: string): number {
  const match = DATE.exec(value);
  if (!match) return NaN;
  const [year, month, day] = match.slice(1).map(Number);
  if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate()) return NaN;
  return Date.UTC(year, month - 1, day) - JST_OFFSET;
}

export function jstDateString(value: Date | string | number = serverTime.now()): string {
  const dateOnly = typeof value === 'string' && DATE.test(value);
  const timestamp = dateOnly ? jstDayStart(value) : new Date(value).getTime();
  return Number.isFinite(timestamp) ? new Date(timestamp + JST_OFFSET).toISOString().slice(0, 10) : '';
}

export function nextJstDateString(value: string): string {
  return jstDateString(jstDayStart(value) + DAY);
}

export function isWithinJstDateRange(value: string, from: string, to: string): boolean {
  if (!from && !to) return true;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) && (!from || timestamp >= jstDayStart(from)) &&
    (!to || timestamp < jstDayStart(to) + DAY);
}
